import type { MenuProps as AntdMenuProps } from 'antd';
import { Menu as AntdMenu } from 'antd';
import type {
  MenuItemType as AntdMenuItemType,
  SubMenuType as AntdSubMenuType,
  MenuDividerType,
} from 'antd/es/menu/interface';

export interface MenuItemType<K extends string> extends AntdMenuItemType {
  key: K;
  'data-test'?: string;
  'data-testid'?: string;
}

export interface SubMenuType<K extends string> extends AntdSubMenuType {
  key: K;
  'data-test'?: string;
  'data-testid'?: string;
}

export type ItemType<K extends string> = MenuItemType<K> | SubMenuType<K> | MenuDividerType | null;

export interface MenuProps<K extends string> extends Omit<
  AntdMenuProps,
  'onSelect' | 'onDeselect'
> {
  items?: Array<ItemType<K>>;
  openKeys?: Array<NoInfer<K>>;
  defaultSelectedKeys?: Array<NoInfer<K>>;
  selectedKeys?: Array<NoInfer<K>>;
}

export const Menu = <K extends string>(props: MenuProps<K>) => <AntdMenu {...props} />;
